import btnStyle from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Button, Divider, type MantineSize, Stack, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
export type ProfileRegistrationProps = {
  visible?: (string & {}) | MantineSize | undefined;
};
export const ProfileRegistration: React.FC<ProfileRegistrationProps> = ({
  visible
}) => {
  const {
    i18n
  } = useLingui();
  const {
    setVerifyStatus
  } = useVerifyProfile();
  const isMobile = useMediaQuery('(max-width: 30em)');
  return <Stack gap={10} justify="center" align="center" visibleFrom={visible} h={{
    sm: 'calc(100vh - 135px)',
    lg: 'auto'
  }}>
      <Stack maw={320} mt={{
      base: 40,
      sm: 0,
      lg: 40
    }}>
        <Text c="var(--text-dark)" fz="xs" fw={700} tt="uppercase" ta={{
        base: 'center',
        sm: 'left'
      }}>
          {i18n._(`Your PrimeOrb's rank provides endless benefits such as:`)}
        </Text>
        <Divider size="sm" c="var(--icon-primary)" />
        <Text className={gunterzBold.className} fz={20} variant="gradient" ta={{
        base: 'center',
        sm: 'left'
      }} gradient={{
        from: '#FF99F3',
        to: '#FF2980',
        deg: 135
      }}>
          {i18n._('Increased multipliers Instant Rakebacks Weekly bonuses Surprise Loot Boxes Discount bonuses')}
        </Text>
        <Divider size="sm" c="var(--icon-primary)" />
        <Text fz="xs" tt="uppercase" c="var(--text-dark)" fw={700} ta={{
        base: 'center',
        sm: 'left'
      }}>
          {i18n._('Complete the steps below to claim your first armor and ')}
          <Text span inherit c="var(--text-prime)">
            {i18n._('get UP TO A 1.3x multiplier!')}
          </Text>
        </Text>
        <Button classNames={btnStyle} w={202} h={46} mt={25} mx={{
        base: 'auto',
        sm: 0
      }} fz={13} fw={700} leftSection={!isMobile && <Icons className="icon-pr-line-log-in" fontSize={25} />} onClick={() => setVerifyStatus(PROFILE_STATUS.VERIFY)}>
          {i18n._('CLICK TO CONTINUE')}
        </Button>
      </Stack>
    </Stack>;
};